import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const TextBooksIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.4475 3.33301C13.4473 2.87303 13.0759 2.50018 12.6177 2.5H3.32005C2.86186 2.50018 2.49046 2.87303 2.49028 3.33301V12.667C2.49046 13.127 2.86186 13.4998 3.32005 13.5H12.6177C13.0759 13.4998 13.4473 13.127 13.4475 12.667V3.33301ZM14.4436 12.667C14.4434 13.6793 13.626 14.4998 12.6177 14.5H3.32005C2.31172 14.4998 1.49435 13.6793 1.49417 12.667V3.33301C1.49435 2.32074 2.31172 1.50018 3.32005 1.5H12.6177C13.626 1.50018 14.4434 2.32074 14.4436 3.33301V12.667Z"
      fill="currentColor"
    />
    <path
      d="M4.15045 11.3336V4.66666C4.15045 4.39051 4.37344 4.16666 4.64851 4.16666C4.92357 4.16666 5.14656 4.39051 5.14656 4.66666V11.3336C5.14639 11.6096 4.92347 11.8336 4.64851 11.8336C4.37355 11.8336 4.15063 11.6096 4.15045 11.3336Z"
      fill="currentColor"
    />
    <path
      d="M6.80673 11.3336V4.66666C6.80673 4.39051 7.02972 4.16666 7.30479 4.16666C7.57985 4.16666 7.80284 4.39051 7.80284 4.66666V11.3336C7.80267 11.6096 7.57975 11.8336 7.30479 11.8336C7.02983 11.8336 6.80691 11.6096 6.80673 11.3336Z"
      fill="currentColor"
    />
    <path
      d="M9.86381 4.17644C10.1334 4.12252 10.3955 4.29836 10.4494 4.56902L11.7772 11.235C11.8312 11.5057 11.6568 11.7697 11.3872 11.8239C11.1174 11.8781 10.8545 11.7021 10.8006 11.4313L9.47276 4.76433C9.41905 4.49368 9.5942 4.23057 9.86381 4.17644Z"
      fill="currentColor"
    />
  </svg>
);
